import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import React from 'react';

import { useMqSelect } from '@fhs/ui';

import { AppHeader } from '../../components/app-header';
import { ServiceModeDialog } from '../../service-mode-dialog';

export default function TabsWebLayout() {
  const isDesktopWeb = useMqSelect({ $gteDesktop: true }, false);

  return (
    <>
      <Head>
        <title>Firehouse Subs - Subs, Sub Sandwiches, Salads, Catering -- Firehouse Subs</title>
        <meta
          name="description"
          content="Order Firehouse Subs online for pickup, delivery, or catering. Find locations, explore the menu, and earn rewards."
        />
      </Head>
      {isDesktopWeb && <AppHeader />}
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen
          name="index"
          options={{
            header: () => <AppHeader />,
            headerShown: !isDesktopWeb,
          }}
        />
      </Stack>
      <ServiceModeDialog />
    </>
  );
}
